import { CASINO_GAMES_SEARCH_TYPES, initStore } from '../../../common';
import { actions } from './actions';

export const gamesStore = (): void => {
	const initialState = {
		slice: 'CASINO_GAMES',
		games: [],
		gamesLoading: false,
		savingData: false,
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		bulkRows: [],
		columns: [],
		partners: [],
		providers: [],
		AAMS_types: [],
		gameCategories: [],
		checksumStatuses: [],
		categoryForm: { categories: [] },
		gamePartnersForm: { gamePartners: ['1'] },
		activePartners: [],
		perPage: '10',
		infoText: 'Please upload your file',
		active: [
			{ value: '0', label: 'Disabled', isChecked: false },
			{ value: '1', label: 'Enabled', isChecked: false },
		],
		is_slot: [{ value: '1', label: 'Slot', isChecked: false }],
		filtering: false,
		filters: [{ name: 'searchType', value: CASINO_GAMES_SEARCH_TYPES[0].value }],
		globalErrors: [],
		selectedGame: null,
		gameForm: {
			game_name: '',
			custom_game_id: '',
			assigned_partners: [],
			notes: '',
			game_provider_id: [],
			provider_game_id_desktop: '',
			provider_game_id_mobile: '',
			aams_type_id: [],
			rtp: '',
			volatility: '',
			wagering_weight: '',
			is_slot: false,
			active: false,
			custom_fields: [],
			aams_game_id: '',
		},
		importGameForm: {
			file: '',
		},
		bulkAssignPartnersForm: {
			file: '',
		},
		bulkEnableGamesForm: {
			file: '',
		},
		formErrors: {},
		globalSuccess: '',
		allSkins: [],
		gameData: [],
	};

	initStore(actions, initialState);
};
